<fx-tab
[tabs]="tabs"
[activeTab]="tabSelect"
(selected)="onChangeTab($event)">
</fx-tab>
<fx-customers
  [hidden]="router.url.includes('/detail?')"
*ngIf="tabSelect == tabs[0]"
[permission]="permission"
></fx-customers>
<router-outlet></router-outlet>
<rox-suspended-users
*ngIf="tabSelect == tabs[1]">
</rox-suspended-users>
